import React from 'react'
import './styles'

import { Link } from 'react-router-dom'

# componennts
import UserCard     from '/components/user-card'
import Pager        from '/components/pager/history-pager'
import DropdownMenu from '/components/dropdown-menu'
import Spinner      from '/components/spinner'
import Datetime     from '/components/datetime'
import StateLabel   from '/components/state-label'
import List         from '/components/list'
import Filters      from '/components/filters'
import DeliveryChart  from '/components/delivery-chart'

import FaCloudDownload  from 'react-icons/lib/fa/cloud-download'

import {
  state_options
  delivery_state_options
  type_options
} from '/models/email'

import {
  withEvent
  withEmails
  withEmailStats
} from './queries'

export default \
withEvent \
withEmails \
withEmailStats \
class Emails extends React.Component

  render: ->
    <div className="Emails">
      <header>
        <h1>Emails</h1>
      </header>
      <section className="content">
        {<DeliveryChart stats={@props.emailStats} /> if @props.emailStats}
        {@filters()}
        {@list()}
        {@pager()}
      </section>
    </div>

  filters: ->
    <Filters>
      <Filters.Search/>
      <Filters.State label='Sending State' options={state_options}/>
      <Filters.State label='Receiver State' name='delivery_state' options={delivery_state_options}/>
      <Filters.Type options={type_options}/>
      <span className="pull-right">
        <Pager meta={@props.emailsPagination} buffer={2}/>
      </span>
    </Filters>


  list: ->
    return <Spinner/> if @props.emailsLoading
    <List>
      {@header()}
      {for email in @props.emails
        <List.Row key={email._key}>
          <List.Cell className="to" title={email.to}>
            {if email.user
              <UserCard user={email.user} />
            else
              <span>{email.to}</span>
            }
          </List.Cell>
          <List.Cell className="subject" title={email.subject}>
            {email.subject}
            <br/>
            <small>{email.type.replace /_/g, ' '}</small>
          </List.Cell>
          <List.Cell className="created_at">
            <Datetime date={email.created_at}/>
          </List.Cell>
          <List.Cell className="opens">{email.opens}</List.Cell>
          <List.Cell className="clicks">{email.clicks}</List.Cell>
          <List.Cell className="download">
            <a className="btn btn-default #{'disabled' unless email.s3_url}" href={email.s3_url}>
              <FaCloudDownload/>
            </a>
          </List.Cell>
          <List.Cell className="actions">
            <StateLabel model={email}/>
          </List.Cell>
          <List.Cell className="actions">
            <StateLabel model={email} state={email.delivery_state} title={email.delivery_message}/>
          </List.Cell>
        </List.Row>
      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="to">To</List.Header>
      <List.Header className="subject">Subject</List.Header>
      <List.Header className="created-at">Created</List.Header>
      <List.Header className="opens">Opens</List.Header>
      <List.Header className="clicks">Clicks</List.Header>
      <List.Header className="download">Download</List.Header>
      <List.Header className="actions">Sending State</List.Header>
      <List.Header className="actions">Receiver State</List.Header>
    </List.HeaderRow>

  pager: ->
    <div className="text-center">
      <Pager meta={@props.emailsPagination} buffer={4}/>
    </div>
